module.exports = __webpack_public_path__ + "static/media/16.4c367e5e.png";